const ROLE_HOME_ROUTES = {
  CHAUFFEUR: '/field-ops',
};

export const homeRouteForRole = (role) => ROLE_HOME_ROUTES[role] || null;
